/* angular:styles/component:scss;c74b5149c3adc0dbc718d0e08f8afd9e843aac62b9192bb99e504a579909c7b6;D:\Techriff-Project\3amautocare\Autocare.Api\ClientApp\src\app\Formly\custom-types\custom-year-picker.type.ts */
::ng-deep .p-highlight {
  color: #D47500;
  background: #FFF1E0;
}
.p-error {
  color: #e24c4c;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}
/*# sourceMappingURL=custom-year-picker.type-HSV7D3NT.css.map */
